import { getTrackingData } from '@app/infrastructure/gtm/getTrackingData';

export function pushToDataLayer(event: string, data?: Record<string, unknown>): void {
    if (typeof window === 'undefined') {
        return;
    }

    if (!window.dataLayer) {
        window.dataLayer = [];
    }

    const trackingData = getTrackingData();

    window.dataLayer.push({
        event,
        ...trackingData,
        ...data,
    });
}
